import { SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";
import Flex from "./Flex";
import InfoTooltipIcon from "./InfoTooltipIcon";
import Text from "./Text";
import { CHART_COLORS, CHART_TYPOGRAPHY } from "./app/provider/patient/chart";

export type InfoLabelProps = {
  label: ReactNode;
  /** Renders an info icon that reveals this content on hover. */
  info?: ReactNode;
  required?: boolean;
  sx?: SxProps<Theme>;
};

/**
 * Field label with an optional required marker and hover-help icon.
 *
 * @author Rajkumar Rathod
 */
const InfoLabel = ({ label, info, required, sx }: InfoLabelProps) => {
  return (
    <Flex alignItems="center" gap={0.5} sx={sx}>
      <Text {...CHART_TYPOGRAPHY.body5} c={CHART_COLORS.textLabel}>
        {label}
        {required && (
          <Text component="span" c="error.main">
            {" *"}
          </Text>
        )}
      </Text>

      {!!info && <InfoTooltipIcon content={info} />}
    </Flex>
  );
};

export default InfoLabel;
